import React from 'react';
import { MapPin, Award, Users } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../constants';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-sky-50 via-white to-amber-50 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-sky-200 rounded-full opacity-20 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-200 rounded-full opacity-20 blur-3xl"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block px-4 py-2 bg-sky-100 rounded-full">
              <p className="text-sky-700 font-semibold text-sm">Lisans No: {companyInfo.license}</p>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Profesyonel
              <span className="block text-sky-600 mt-2">Harita Mühendisliği</span>
              <span className="block text-gray-700 text-3xl sm:text-4xl mt-2">Hizmetleri</span>
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Ağrı ili genelinde lisanslı harita mühendisliği hizmetleri. Arazi ölçümü, kadastro işlemleri ve aplikasyon hizmetlerinde güvenilir çözüm ortağınız.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                onClick={scrollToContact}
                className="bg-sky-600 hover:bg-sky-700 text-white px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all"
              >
                Hemen İletişime Geçin
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                onClick={() => {
                  const element = document.getElementById('services');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="border-2 border-sky-600 text-sky-600 hover:bg-sky-50 px-8 py-6 text-lg transition-all"
              >
                Hizmetlerimiz
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 pt-8">
              <div className="text-center p-4 bg-white rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                <Award className="w-8 h-8 text-sky-600 mx-auto mb-2" />
                <p className="text-2xl font-bold text-gray-900">Lisanslı</p>
                <p className="text-sm text-gray-600">Resmi Yetki</p>
              </div>
              <div className="text-center p-4 bg-white rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                <MapPin className="w-8 h-8 text-sky-600 mx-auto mb-2" />
                <p className="text-2xl font-bold text-gray-900">Ağrı</p>
                <p className="text-sm text-gray-600">İl Geneli</p>
              </div>
              <div className="text-center p-4 bg-white rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                <Users className="w-8 h-8 text-sky-600 mx-auto mb-2" />
                <p className="text-2xl font-bold text-gray-900">Profesyonel</p>
                <p className="text-sm text-gray-600">Hizmet</p>
              </div>
            </div>
          </div>

          {/* Right Content - Visual */}
          <div className="relative hidden lg:block">
            <div className="relative bg-gradient-to-br from-sky-500 to-sky-700 rounded-2xl p-12 shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <div className="bg-white rounded-lg p-8 space-y-6">
                <div className="flex items-center space-x-4 pb-4 border-b border-gray-200">
                  <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center">
                    <MapPin className="w-8 h-8 text-sky-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-xl text-gray-900">{companyInfo.engineer}</h3>
                    <p className="text-gray-600">{companyInfo.title}</p>
                  </div>
                </div>
                
                <div className="space-y-3">
                  <div className="flex justify-between items-center py-2">
                    <span className="text-gray-600">Lisans No:</span>
                    <span className="font-semibold text-gray-900">{companyInfo.license}</span>
                  </div>
                  <div className="flex justify-between items-center py-2">
                    <span className="text-gray-600">Yetki Alanı:</span>
                    <span className="font-semibold text-gray-900">Ağrı İli</span>
                  </div>
                  <div className="flex justify-between items-center py-2">
                    <span className="text-gray-600">Durum:</span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full bg-green-100 text-green-700 font-semibold text-sm">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse"></span>
                      Aktif
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;